import {REHYDRATE} from 'redux-persist'
import {UPDATE_ITEMS, DELETE_ITEM, ADD_ITEM, EDIT_ITEM, PUT_SUCCESS, ADD_ITEMS} from "./actions";
import {LOGOUT} from "../auth/actions";

const initialState = {
    'items': [],
    'put': [],
    'version': 0,
};

function createVersionedCollectionReducer(collectionName) {
    return function itemsReducer(state = initialState, action) {
        const name = collectionName.toUpperCase();
        const nameLower = collectionName.toLowerCase();
        switch (action.type) {
            case `${UPDATE_ITEMS}_${name}`:
                // const itemIds = state.items.map(x => {
                //     return x.id
                // });
                const modifiedItemsIds = action.changed_items.map(x => {
                    return x.id
                });
                const notChangedItems = state.items.filter(x => {
                    return modifiedItemsIds.indexOf(x.id) === -1
                })
                const modifiedItems = action.changed_items.filter(x => {
                    return (x.state === 'edited' || x.state === 'changed')
                });

                const items = [...notChangedItems, ...modifiedItems]

                // const items = [...state.items, ...itemsToAdd].filter(x => {
                //     return itemIdsToDelete.indexOf(x.id) === -1
                // });
                return {...state, version: action.version, items: items};
            case `${ADD_ITEM}_${name}`:
                const newItem = {...action.item, permission: 4};
                return {...state, items: [...state.items, newItem], put: [...state.put, {...newItem, state: 'edited'}]};
            case `${ADD_ITEMS}_${name}`:
                const newItems = action.items.map(c => ({...c, permission: 4}))
                return {...state, items: [...state.items, ...newItems], put: [...state.put, ...[...newItems.map(c => ({...c, state: 'edited'}))]]};
            case `${DELETE_ITEM}_${name}`:
                return {...state, items: state.items.filter(x => x.id !== action.item.id), put: [...state.put, {...action.item, state: 'deleted'}]};
            case `${EDIT_ITEM}_${name}`:
                const editedItem = {...action.item, ...action.changes};
                return {...state, items: [...state.items.filter(x => x.id !== action.item.id), editedItem], put: [...state.put.filter(x => x.id !== action.item.id), {...editedItem, state: 'edited'}]};
            case `${PUT_SUCCESS}_${name}`:
                return {...state, put: []};
            case REHYDRATE:
                if (action.payload) {
                    const incoming = action.payload[nameLower];
                    if (incoming) {
                        return {...state, items: incoming.items, put: incoming.put, version: incoming.version};
                    }
                    return state;
                }
                return state;
            case LOGOUT:
                return {...initialState};
            default:
                return state;
        }
    }
}

export default createVersionedCollectionReducer;


// WEBPACK FOOTER //
// ./src/store/generic/reducer.js